import { API_LOG_IN_ADMIN_FAILURE, API_LOG_IN_ADMIN_SUCCESS } from "./login";



const API_ASSIGNMENT_REQUEST_REQUEST = 'API_ASSIGNMENT_REQUEST_REQUEST';
const API_ASSIGNMENT_REQUEST_SUCCESS = 'API_ASSIGNMENT_REQUEST_SUCCESS';
const API_ASSIGNMENT_REQUEST_FAILURE = 'API_ASSIGNMENT_REQUEST_FAILURE';

const EXAM_SUBMIT_REQUEST = 'EXAM_SUBMIT_REQUEST';
const EXAM_SUBMIT_SUCCESS = 'EXAM_SUBMIT_REQUEST';
const EXAM_SUBMIT_FAILURE = 'EXAM_SUBMIT_REQUEST';

const API_ASSIGNMENT_SUBMIT_REQUEST = 'API_ASSIGNMENT_SUBMIT_REQUEST';
const API_ASSIGNMENT_SUBMIT_SUCCESS = 'API_ASSIGNMENT_SUBMIT_SUCCESS';
const API_ASSIGNMENT_SUBMIT_FAILURE = 'API_ASSIGNMENT_SUBMIT_FAILURE';

const SET_COMMENT = 'SET_COMMENT';
const SET_FILE = 'SET_FILE';
const SET_FILE_COUNT = 'SET_FILE_COUNT';
const SET_MEDIA_TYPE = 'SET_MEDIA_TYPE';
const RESET_FETCH = 'RESET_FETCH';
const SET_FILE_INDEX = 'SET_FILE_INDEX';

const SELECT_REQUEST_TYPE = 'SELECT_REQUEST_TYPE'

export const assignmentRequestRequest = payload => ({
  type: API_ASSIGNMENT_REQUEST_REQUEST,
  payload: payload
});

export const setComment = payload => ({
  type: SET_COMMENT,
  payload: payload
});

export const setFileIndex= payload => ({
  type: SET_FILE_INDEX,
  payload: payload
});
export const resetFetch = () => ({
  type: RESET_FETCH,

});
export const setFile = payload => ({
  type: SET_FILE,
  payload: payload
});
export const setFileCount = payload => ({
  type: SET_FILE_COUNT,
  payload: payload
});
export const setMediaType = payload => ({
  type: SET_MEDIA_TYPE,
  payload: payload
});
export const assignmentRequestSuccess = payload => ({
  type: API_ASSIGNMENT_REQUEST_SUCCESS,
  payload,
});

export const assignmentRequestFailure = payload => ({
  type: API_ASSIGNMENT_REQUEST_FAILURE,
  payload,
});

export const assignmentSubmitSuccess = payload => ({
  type: API_ASSIGNMENT_SUBMIT_SUCCESS,
  payload,
});

export const assignmentSubmitRequest = payload => ({
  type: EXAM_SUBMIT_REQUEST,
  payload: payload
});

export const examRequestFailure = payload => ({
  type: EXAM_SUBMIT_FAILURE,
  payload,
});

export const examSubmitSuccess = payload => ({
  type: EXAM_SUBMIT_SUCCESS,
  payload,
});

export const examSubmitRequest = payload => ({
  type: API_ASSIGNMENT_SUBMIT_REQUEST,
  payload: payload
});

export const assignmentSubmitFailure = payload => ({
  type: API_LOG_IN_ADMIN_FAILURE,
  payload,
});
export const setRequestType = payload => ({
  type: SELECT_REQUEST_TYPE,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  assignmentRequestType: null,
  retakeMesssage:null,
  comment: null,
  file: [],
  fileIndex: 0,
  file_count:0,
  media_type:null,
  submitInfo:{}
};

export function assignmentRequest(state = initialState, action) {

  switch (action.type) {
    case EXAM_SUBMIT_REQUEST:
      return {
        ...state,
        assignmentRequestType:action.payload
      };
      case EXAM_SUBMIT_SUCCESS:
    
        return {
          ...state
        };
        case EXAM_SUBMIT_FAILURE:
    
          return {
            ...state
          };
    case API_ASSIGNMENT_REQUEST_REQUEST:
   
   if(action.payload=='retake' || action.payload=='extension'){
    return {
      ...state,
      fetching: true,
      isFetched: false,
      assignmentRequestType: action.payload
    };
   }
   case SELECT_REQUEST_TYPE:
    
    return {
      ...state,
      assignmentRequestType:action.payload
    };
    
    case SET_FILE_COUNT:
    return {
      ...state,
      file_count:action.payload
    };
    case SET_FILE_INDEX:
      return {
        ...state,
        fileIndex:action.payload
      };
    case RESET_FETCH:
      return {
        ...state,
        isFetched:false
      };
    case SET_FILE:
    return {
      ...state,
      file:action.payload
    };
    case SET_MEDIA_TYPE:
    return {
      ...state,
      media_type:action.payload
    };
     
    case API_ASSIGNMENT_REQUEST_SUCCESS:
    
      return {
        ...state,
        error: null,
        fetching: false,
        isFetched: true,
        retakeMesssage: action.payload
      };
      case SET_COMMENT:
        return {
          ...state,
          comment:action.payload
        };
    case API_ASSIGNMENT_REQUEST_FAILURE:
    
      return {
        ...state,
        fetching: false,
        isFetched: false,
        error: action.payload,
      };

      case API_ASSIGNMENT_SUBMIT_REQUEST:
        return {
          ...state,
          error: null,
          fetching: false,
          isFetched: true,
          submitInfo: action.payload
        };
        case SET_COMMENT:
          return {
            ...state,
            comment:action.payload
          };
      case API_ASSIGNMENT_SUBMIT_FAILURE:
      
        return {
          ...state,
          fetching: false,
          isFetched: false,
          error: action.payload,
        };
    default:
      return state;
  }
}
